module.exports = __webpack_public_path__ + "img/444108880.f591ae18.svg";